import { Component, OnInit, Inject } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Pagination } from "@shared/models/pagination";

interface PropsType {
  invoicesPendencies: Pagination<string[]>;
  budgetPendencies: Pagination<string[]>;
  preventiveProposals: Pagination<string[]>;
}

@Component({
    selector: "app-driveb-car-workshop-pendecies-modal",
    templateUrl: "./car-workshop-pendecies-modal.component.html",
    styleUrls: ["./car-workshop-pendecies-modal.component.scss"],
    standalone: false
})
export class CarWorkshopPendeciesModalComponent implements OnInit {
  option = new UntypedFormControl("vehicleData");
  invoicesPendencies = [];
  totalInvoicesPendencies = 0;
  budgetPendencies = [];
  totalBudgetPendencies = 0;
  preventiveProposals = [];
  totalPreventiveProposals = 0;

  constructor(
    private matDialogRef: MatDialogRef<CarWorkshopPendeciesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: PropsType
  ) {}

  ngOnInit() {
    this.invoicesPendencies = this.data.invoicesPendencies.content;
    this.totalInvoicesPendencies = this.data.invoicesPendencies.totalElements;
    this.budgetPendencies = this.data.budgetPendencies.content;
    this.totalBudgetPendencies = this.data.budgetPendencies.totalElements;
    this.preventiveProposals = this.data.preventiveProposals.content;
    this.totalPreventiveProposals = this.data.preventiveProposals.totalElements;

    if (this.totalInvoicesPendencies) {
      this.option.setValue("invoicesPendencies");
    } else if (this.totalBudgetPendencies) {
      this.option.setValue("budgetPendencies");
    } else if (this.totalPreventiveProposals) {
      this.option.setValue("preventiveProposals");
    }
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  goToServicesRequestTable() {
    this.matDialogRef.close(this.option.value);
  }
}
